import get from './methods/get';

export default {
	get: (headers) => get('account', headers),
};
